(function TripSummaryAgentLibrary($, Adzuki)
{
	'use strict';

	let myComponentsDrake;
	let sharedComponentsDrake;

	// TS-416 QA: hides only the tooltips that exist -- see clearTooltips() in
	// ts_agent_schedule.js. $(...).tooltip('hide') created a Bootstrap 5
	// instance on every element it touched.
	function clearTooltips() {
		document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
			const tooltip = (window.bootstrap ? window.bootstrap.Tooltip.getInstance(el) : null);

			if (tooltip) {
				tooltip.hide();
			}
		});

		$('.tooltip').remove();
	}

	// a press on the click-to-add controls must not start a drag
	function isPickerControl(handle) {
		return Boolean(handle && handle.closest && handle.closest('.ts-library-add-controls, .ts-library-add-toggle'));
	}

	const component = {
		template: '#ts-agent-library',
		emits   : ['addComponentFromLibrary'],
		inject  : [
			'formatDate',
			'formatShortDate',
			'formatTime',
			'getFaIconStyle',
			'isEmptyObject',
		],
		props: {
			components: {
				type   : Array,
				default: [],
			},
			itinerary: {
				type   : Object,
				default: {},
			},
			loadingTripSummary: {
				type   : Boolean,
				default: false,
			},
			// TS-415: the click-to-add picker needs what the day containers'
			// data-* attributes give the drop handler
			fitBuilderId: {
				type   : [String, Number],
				default: null,
			},
			sectionMode: {
				type   : Boolean,
				default: false,
			},
		},
		data() {
			return {
				search   : '',
				// TS-415: which library component has its "Add to" picker open
				pickerFor: null,
				pickerDay: null,
			};
		},
		computed: {
			// one option per itinerary day, in day order, labelled as the day
			// headers are (getItineraryDayLabel in ts_agent_schedule.js)
			dayOptions() {
				const noun = this.sectionMode ? 'Section' : 'Day';

				return Object.keys(this.itinerary || {})
					.map((key) => parseInt(key))
					.filter((dayNumber) => !isNaN(dayNumber))
					.sort((a, b) => a - b)
					.map((dayNumber) => {
						const day   = this.itinerary[dayNumber];
						const label = (day && day.label) || `${noun} ${dayNumber}`;

						return {
							value: dayNumber,
							label: (day && day.date) ? `${label} - ${this.formatShortDate(day.date)}` : label,
						};
					});
			},
			myComponents() {
				return this.components
					.filter((component) => {
						const found = this.searchedComponent(component);

						return component.shared === false && found;
					})
					// Most-recently-added first: id is the library row's auto-increment
					// PK, so a higher id was added later (matches the backend ORDER BY
					// id DESC; enforced here so order holds regardless of payload order).
					.sort((a, b) => b.id - a.id);
			},
			sharedComponents() {
				return this.components
					.filter((component) => {
						const found = this.searchedComponent(component);

						return component.shared === true && found;
					})
					// Most-recently-added first: id is the library row's auto-increment
					// PK, so a higher id was added later (matches the backend ORDER BY
					// id DESC; enforced here so order holds regardless of payload order).
					.sort((a, b) => b.id - a.id);
			},
		},
		methods: {
			addFromLibrary(fitBuilderId, componentId, dayNumber, date) {
				const eventData = {
					fitBuilderId,
					componentId,
					dayNumber,
					date,
				};

				this.$emit('addComponentFromLibrary', eventData);
			},
			openPicker(component) {
				this.pickerFor = component.id;

				if (!this.dayOptions.some((day) => day.value === this.pickerDay)) {
					this.pickerDay = this.dayOptions.length ? this.dayOptions[0].value : null;
				}
			},
			// same arguments the drop handler reads off the day container
			addPicked(component) {
				const day = this.itinerary[this.pickerDay];

				if (!day) {
					return;
				}

				let fitBuilderId = this.fitBuilderId;

				if (fitBuilderId !== 'new') {
					fitBuilderId = parseInt(fitBuilderId);
				}

				this.pickerFor = null;

				this.addFromLibrary(fitBuilderId, component.id, this.pickerDay, day.date);
			},
			searchedComponent(component) {
				let titleFound       = true;
				let descriptionFound = true;
				let tagsFound        = true;

				if (this.search && this.search.trim().length > 0) {
					titleFound       = false;
					descriptionFound = false;
					tagsFound        = false;

					if (component.title && component.title.trim().length > 0) {
						titleFound = component.title.toLowerCase().includes(this.search.toLowerCase());
					}

					if (component.description && component.description.trim().length > 0) {
						descriptionFound = component.description.toLowerCase().includes(this.search.toLowerCase());
					}

					if (component.tags && component.tags.length > 0) {
						tagsFound = component.tags.some((tag) => tag.name.toLowerCase().includes(this.search.toLowerCase()));
					}
				}

				return titleFound || descriptionFound || tagsFound;
			},
			truncate(text, length) {
				return Adzuki.String.truncate(text, length);
			},
			async updateDragulaContainers() {
				await this.$nextTick();

				const dayComponentsContainers = document.querySelectorAll('.ts-day-components-container');

				myComponentsDrake.containers     = [];
				sharedComponentsDrake.containers = [];

				if (this.$refs.myComponentsContainer) {
					myComponentsDrake.containers.push(this.$refs.myComponentsContainer);
				}

				if (this.$refs.sharedComponentsContainer) {
					sharedComponentsDrake.containers.push(this.$refs.sharedComponentsContainer);
				}

				if (dayComponentsContainers.length > 0) {
					for (const container of dayComponentsContainers) {
						myComponentsDrake.containers.push(container);
						sharedComponentsDrake.containers.push(container);
					}
				}

				// auto scroll the itinerary when dragging a day or component
				const componentsContainer = document.querySelector('.ts-components-container');

				autoScroll([
					window,
					componentsContainer,
				], {
					margin    : 50,
					pixels    : 50,
					maxSpeed  : 50,
					autoScroll: function autoScrolling() {
						return this.down && (myComponentsDrake.dragging || sharedComponentsDrake.dragging);
					}
				});
			}
		},
		watch: {
			components: {
				handler() {
					this.updateDragulaContainers();
				},
				once: false,
				deep: true,
			},
			itinerary: {
				handler() {
					this.updateDragulaContainers();
				},
				once: false,
				deep: true,
			},
		},
		mounted() {
			// initialize dragula that handles adding my components from the library to the schedule
			myComponentsDrake = dragula({
				moves: (el, source, handle) => {
					// the whole <li> element is draggable, except the TS-415 picker
					return el.classList.contains('ts-library-component') && !isPickerControl(handle);
				},
				invalid: (el, handle) => {
					return el.classList.contains('ts-day-component');
				},
				revertOnSpill  : true,
				copy           : true,
				mirrorContainer: document.getElementById('ts-itinerary'),
			});

			// handle when a component is dropped
			myComponentsDrake.on('drop', (el, target, source, sibling) => {
				let fitBuilderId   = target.dataset.fitBuilderId;
				const componentId  = parseInt(el.dataset.id);
				const dayNumber    = parseInt(target.dataset.dayNumber);
				const date         = target.dataset.date;

				if (fitBuilderId !== 'new') {
					fitBuilderId = parseInt(fitBuilderId);
				}

				myComponentsDrake.cancel();

				this.addFromLibrary(fitBuilderId, componentId, dayNumber, date);
			});

			myComponentsDrake.containers = [];

			// initialize dragula that handles adding shared components from the library to the schedule
			sharedComponentsDrake = dragula({
				moves: (el, source, handle) => {
					// the whole <li> element is draggable, except the TS-415 picker
					return el.classList.contains('ts-library-component') && !isPickerControl(handle);
				},
				invalid: (el, handle) => {
					return el.classList.contains('ts-day-component');
				},
				revertOnSpill  : true,
				copy           : true,
				mirrorContainer: document.getElementById('ts-itinerary'),
			});

			// handle when a shared component is dropped
			sharedComponentsDrake.on('drop', (el, target, source, sibling) => {
				let fitBuilderId   = target.dataset.fitBuilderId;
				const componentId  = parseInt(el.dataset.id);
				const dayNumber    = parseInt(target.dataset.dayNumber);
				const date         = target.dataset.date;

				if (fitBuilderId !== 'new') {
					fitBuilderId = parseInt(fitBuilderId);
				}

				sharedComponentsDrake.cancel();

				this.addFromLibrary(fitBuilderId, componentId, dayNumber, date);
			});

			sharedComponentsDrake.containers = [];

			// TS-416: a library drag crosses the day grips and titles on its way to
			// a day, and the add redraws that day, so the same tooltips get orphaned
			// as on a rail drag. Same cleanup as ts_agent_schedule.js.
			for (const drake of [myComponentsDrake, sharedComponentsDrake]) {
				drake.on('drag', clearTooltips);
				drake.on('dragend', clearTooltips);
			}
		},
		beforeUnmount() {
			if (myComponentsDrake) {
				myComponentsDrake.destroy();
				myComponentsDrake = null;
			}

			if (sharedComponentsDrake) {
				sharedComponentsDrake.destroy();
				sharedComponentsDrake = null;
			}
		},
	};

	Adzuki.VueComponents.TripSummaryAgentLibrary = component;
}(jQuery, window.Adzuki || {}));
